#import "../fragments/onboarding-checklist-item-fragment.graphql"

query GetMarketingDashboardChecklist {
    marketingDashboardChecklist {
        items {
            ...OnboardingChecklistItem
        }
        percentComplete
        isAvailable
        canRemove
    }
}
